module.exports = __webpack_public_path__ + "static/media/joincertified.747b13da.jpg";